import React from 'react';
import bhs from './../../image/education/bhs.jpg'
import lpsrLogo from './../../image/experience/lapasar/lapasar-logo.png'
import lpsrBlackLogo from './../../image/experience/lapasar/lapasar-black.png'

const Experience = () => {
    return (
        <div className=" ex_part">

            <div className="heading">

                <hr />
                <h3 id="experience">Experience</h3>
            </div>
            <div className="edu ">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            <div className="ex">
                                <div className="ex_logo"><img src={lpsrLogo} alt="" /></div>
                                <div className="ex_bg_img"><img src={lpsrBlackLogo} alt="" /></div>
                                <div className="ex_content">
                                    <h4>Full Stack Developer</h4>
                                    <p>June, 2022 - Current Working</p>
                                    <p>Malaysia</p>
                                    <h5 className='font-bold'>Tools</h5>
                                    <p style={{marginBottom: '40px'}}>Typescript, Vuejs, Nuxtjs, Tailwind CSS, GraphQL, Nestjs, Nodejs, MongoDB, Microservice</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Experience;